import Container from "@mui/material/Container";

export default function ContestNotAllowedInLocation(props) {
    let style  = {
        textAlign: 'center',
        padding: '3rem',
    };
    return(<Container sx={style}>Sorry, this contest is not available in your location.</Container>);
}
